/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentDto } from '../../models/enrollment-dto';

export interface EnrollmentControllerFindById$Params {
  id: string;
}

export function enrollmentControllerFindById(http: HttpClient, rootUrl: string, params: EnrollmentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrollmentDto>;
    })
  );
}

enrollmentControllerFindById.PATH = '/api/enrollment/{id}';
